import React, { Component } from "react";

import { Redirect } from "react-router-dom";
import { logout, isLogin } from "../utils";
import { Link } from "react-router-dom";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: isLogin(),
    };
  }

  handleLogout = () => {
    logout();
    this.setState({
      isLogin: false,
    });
  };

  render() {
    return (
      <div>
        {this.state.isLogin ? (
          <Redirect to="/dashboard" />
        ) : (
          <Redirect to="/login" />
        )}
        <h1>Home</h1>

        {this.state.isLogin ? (
          <button onClick={() => this.handleLogout()}>
            Click here to log out
          </button>
        ) : (
          <Link to="/login">Go to sign in page</Link>
        )}
      </div>
    );
  }
}

export default Home;
